import React from 'react';
import leafImage from '../assets/leaf.png';
// Note: Using plant.jpg for the food/garden image, update if needed
import foodImage from '../assets/plant.jpg';

// Custom styles for FoodPhilosophy component
const styles = `
.food-philosophy-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 80px 0;
    padding-bottom: 50px;
}

/* Decorative circle - Top Right */
.food-philosophy-circle-right {
    position: absolute;
    top: -80px;
    right: -80px;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay on circle - Top Right */
.food-philosophy-leaf-right {
    position: absolute;
    top: -60px;
    right: -60px;
    width: 240px;
    height: 240px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

/* Decorative circle - Center Left */
.food-philosophy-circle-left {
    position: absolute;
    top: 50%;
    left: -100px;
    transform: translateY(-50%);
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay on circle - Center Left */
.food-philosophy-leaf-left {
    position: absolute;
    top: 50%;
    left: -80px;
    transform: translateY(-50%);
    width: 180px;
    height: 180px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

.food-philosophy-content-wrapper {
    position: relative;
    z-index: 3;
}

/* Content Layout */
.food-philosophy-content {
    display: flex;
    align-items: flex-start;
    gap: 50px;
    position: relative;
}

/* Text Section */
.food-philosophy-text-section {
    flex: 1;
}

/* Main Heading */
.food-philosophy-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.8rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 25px;
}

/* Content Text */
.food-philosophy-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    font-weight: 500;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.75;
    margin-bottom: 20px;
    text-align: justify;
}

/* Image Section */
.food-philosophy-image-section {
    flex: 0 0 400px;
    max-width: 400px;
    align-self: stretch;
    display: flex;
}

.food-philosophy-image-wrapper {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    width: 100%;
    position: relative;
}

.food-philosophy-image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    object-fit: cover;
    object-position: center;
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .food-philosophy-section {
        padding: 70px 0;
    }
    
    .food-philosophy-heading {
        font-size: 2.5rem;
    }
    
    .food-philosophy-text {
        font-size: 1.05rem;
    }
    
    .food-philosophy-image-section {
        flex: 0 0 350px;
        max-width: 350px;
    }
    
    .food-philosophy-content {
        gap: 40px;
    }
    
    .food-philosophy-circle-right {
        width: 220px;
        height: 220px;
        top: -70px;
        right: -70px;
    }
    
    .food-philosophy-leaf-right {
        width: 190px;
        height: 190px;
        top: -50px;
        right: -50px;
    }
    
    .food-philosophy-circle-left {
        width: 160px;
        height: 160px;
        left: -80px;
    }
    
    .food-philosophy-leaf-left {
        width: 140px;
        height: 140px;
        left: -60px;
    }
}

@media (max-width: 991.98px) {
    .food-philosophy-section {
        padding: 60px 0;
    }
    
    .food-philosophy-heading {
        font-size: 2.2rem;
    }
    
    .food-philosophy-content {
        flex-direction: column;
        align-items: center;
        gap: 35px;
    }
    
    .food-philosophy-text-section {
        width: 100%;
    }
    
    .food-philosophy-image-section {
        flex: 0 0 auto;
        max-width: 450px;
        width: 100%;
        align-self: center;
    }
    
    .food-philosophy-image-wrapper {
        height: auto;
        position: static;
    }
    
    .food-philosophy-image {
        position: static;
        height: auto;
    }
    
    .food-philosophy-text {
        font-size: 1rem;
        text-align: left;
    }
    
    .food-philosophy-circle-right {
        width: 180px;
        height: 180px;
        top: -60px;
        right: -60px;
    }
    
    .food-philosophy-leaf-right {
        width: 150px;
        height: 150px;
        top: -40px;
        right: -40px;
    }
    
    .food-philosophy-circle-left {
        width: 140px;
        height: 140px;
        left: -70px;
    }
    
    .food-philosophy-leaf-left {
        width: 120px;
        height: 120px;
        left: -55px;
    }
}

@media (max-width: 767.98px) {
    .food-philosophy-section {
        padding: 50px 0;
    }
    
    .food-philosophy-heading {
        font-size: 1.8rem;
        margin-bottom: 20px;
    }
    
    .food-philosophy-content {
        gap: 30px;
    }
    
    .food-philosophy-image-section {
        max-width: 380px;
    }
    
    .food-philosophy-text {
        font-size: 0.95rem;
        line-height: 1.7;
        margin-bottom: 15px;
    }
    
    .food-philosophy-circle-right {
        width: 140px;
        height: 140px;
        top: -50px;
        right: -50px;
    }
    
    .food-philosophy-leaf-right {
        width: 120px;
        height: 120px;
        top: -35px;
        right: -35px;
    }
    
    .food-philosophy-circle-left {
        width: 110px;
        height: 110px;
        left: -55px;
    }
    
    .food-philosophy-leaf-left {
        width: 95px;
        height: 95px;
        left: -45px;
    }
    
    .food-philosophy-image-wrapper {
        border-radius: 16px;
    }
}

@media (max-width: 575.98px) {
    .food-philosophy-section {
        padding: 40px 0;
    }
    
    .food-philosophy-heading {
        font-size: 1.5rem;
        margin-bottom: 18px;
    }
    
    .food-philosophy-content {
        gap: 25px;
    }
    
    .food-philosophy-image-section {
        max-width: 320px;
    }
    
    .food-philosophy-text {
        font-size: 0.9rem;
        line-height: 1.65;
        margin-bottom: 12px;
    }
    
    .food-philosophy-circle-right {
        width: 110px;
        height: 110px;
        top: -40px;
        right: -40px;
    }
    
    .food-philosophy-leaf-right {
        width: 95px;
        height: 95px;
        top: -28px;
        right: -28px;
    }
    
    .food-philosophy-circle-left {
        width: 90px;
        height: 90px;
        left: -45px;
    }
    
    .food-philosophy-leaf-left {
        width: 75px;
        height: 75px;
        left: -35px;
    }
    
    .food-philosophy-image-wrapper {
        border-radius: 14px;
    }
}

@media (max-width: 400px) {
    .food-philosophy-section {
        padding: 35px 0;
    }
    
    .food-philosophy-heading {
        font-size: 1.3rem;
    }
    
    .food-philosophy-image-section {
        max-width: 280px;
    }
    
    .food-philosophy-text {
        font-size: 0.85rem;
        line-height: 1.6;
    }
    
    .food-philosophy-circle-right {
        width: 90px;
        height: 90px;
        top: -35px;
        right: -35px;
    }
    
    .food-philosophy-leaf-right {
        width: 75px;
        height: 75px;
        top: -22px;
        right: -22px;
    }
    
    .food-philosophy-circle-left {
        width: 70px;
        height: 70px;
        left: -35px;
    }
    
    .food-philosophy-leaf-left {
        width: 60px;
        height: 60px;
        left: -28px;
    }
    
    .food-philosophy-image-wrapper {
        border-radius: 12px;
    }
}
`;

const FoodPhilosophy = () => {
    return (
        <>
            <style>{styles}</style>
            <section className="food-philosophy-section">
                {/* Decorative Circle - Top Right */}
                <div className="food-philosophy-circle-right"></div>
                {/* Decorative Leaf - Top Right */}
                <div
                    className="food-philosophy-leaf-right"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>
                {/* Decorative Circle - Center Left */}
                <div className="food-philosophy-circle-left"></div>
                {/* Decorative Leaf - Center Left */}
                <div
                    className="food-philosophy-leaf-left"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>

                <div className="container">
                    <div className="food-philosophy-content-wrapper">
                        <div className="food-philosophy-content">
                            {/* Text Section */}
                            <div className="food-philosophy-text-section">
                                <h2 className="food-philosophy-heading">Our Food Philosophy</h2>

                                <p className="food-philosophy-text">
                                    At Zubis Nursery, we believe good food fuels great learning. Our meals teach children to make positive choices, develop independence, and enjoy wholesome, natural food.
                                </p>

                                <p className="food-philosophy-text">
                                    We provide nutritious, home-cooked meals made with fresh ingredients and free from added sugar and salt, all within our nut-free nursery. Meals are freshly prepared daily to give children the energy to play, explore, and learn.
                                </p>
                            </div>

                            {/* Image Section */}
                            <div className="food-philosophy-image-section">
                                <div className="food-philosophy-image-wrapper">
                                    <img
                                        src={foodImage}
                                        alt="Fresh vegetables and garden produce"
                                        className="food-philosophy-image"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FoodPhilosophy;
